<template>
  <main class="page-wrap">
    <header class="page-header">
      <h1 class="title">Copia de Seguridad</h1>
      <p class="subtitle">Respaldo y restauración de datos</p>
    </header>
    <section class="content">
      <div class="card">
        <p class="placeholder-text">
          <span class="material-symbols-rounded icon-large">backup</span>
          <br>
          Módulo en construcción
        </p>
      </div>
    </section>
  </main>
</template>

<style scoped>
.page-wrap {
  padding: 1.5rem;
  display: grid;
  gap: 1.5rem;
  align-content: start;
  background: linear-gradient(135deg, #0a0b14 0%, #1a1610 100%);
  min-height: 100vh;
}

.page-header {
  display: grid;
  gap: 0.25rem;
}

.title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
}

.subtitle {
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.content {
  display: grid;
  gap: 1rem;
}

.card {
  background: var(--surface-card);
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.placeholder-text {
  color: var(--text-secondary);
  font-size: 1.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.icon-large {
  font-size: 3rem;
  opacity: 0.5;
}
</style>
